import { isInHomeWork,isInKd, isInWakeup } from './system';

export const getXiaomiSchema = async () => {
  const domain = location.origin;
  const fromAppId = isInHomeWork ? 'homework' : isInKd ? 'scancode' : isInWakeup ? 'wakeup' : 'browser';
  const { errNo, data } = await fetch(`${domain}/dxapp/mixins/mideeplink?appId=college&fromAppId=${fromAppId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => res.json());
  if (errNo == 0) {
    return data.deeplink;
  }
};
